import React from 'react'
import styles from './style/_global_style.module.scss';
import PropTypes from 'prop-types'


const Foundation = ({ children, ...props }) => {

    const getClasses = () => {
        const propKeys = Object.keys(props)
        const _classes = children.props && children.props.className ? [children.props.className] : []

        propKeys.reduce((classes, prop) => {
            const classProp = prop !== 'className'
                ? styles[prop] : FOUNDATION_PROPTYPES[prop] === PropTypes.string
                    ? props[prop] : null
            if (classProp) classes.push(classProp)
            return classes
        }, _classes)

        return _classes.join(' ')
    }

    const classes = getClasses()
    return React.cloneElement(children, {className: classes})
};

export const FOUNDATION_COLORS = {
    'neutral-900': PropTypes.bool,
    'neutral-700': PropTypes.bool,
    'neutral-600': PropTypes.bool,
    'neutral-400': PropTypes.bool,
    'neutral-100': PropTypes.bool,
    'accent-100': PropTypes.bool,
    'accent-50': PropTypes.bool,
    'white': PropTypes.bool,
    'transparent': PropTypes.bool,
    'secondary': PropTypes.bool,
    'back-neutral-900': PropTypes.bool,
    'back-neutral-700': PropTypes.bool,
    'back-neutral-600': PropTypes.bool,
    'back-neutral-400': PropTypes.bool,
    'back-neutral-100': PropTypes.bool,
    'back-accent-100': PropTypes.bool,
    'back-accent-50': PropTypes.bool,
    'back-white': PropTypes.bool,
    'back-transparent': PropTypes.bool,
}

export const FOUNDATION_PROPTYPES = {
    ...FOUNDATION_COLORS,
    block: PropTypes.bool,
    inline: PropTypes.bool,
    className: PropTypes.string
};

Foundation.propTypes = FOUNDATION_PROPTYPES

export default Foundation;